import { useEffect, useRef, useState } from 'react';

import useUserQuiz from '@/app/experiments/D2CUserQuiz/useUserQuiz';

export function useRingAssessmentModalHandlers() {
  const [open, setOpen] = useState(false);
  const userQuizEnabled = useUserQuiz();
  const timeout = useRef<NodeJS.Timeout | null>(null);

  const removeTimeout = () => {
    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }
  };

  const handleOpen = () => {
    removeTimeout();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    if (userQuizEnabled) {
      timeout.current = setTimeout(() => {
        setOpen(true);
      }, 15000);

      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      removeTimeout();
      document.removeEventListener('keydown', handleEscape);
    };
  }, [userQuizEnabled]);

  return {
    open,
    handleOpen,
    handleClose,
    userQuizEnabled,
  };
}
